import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  buildStructuredData,
  isSupportedStructuredDataLanguage,
  serializeJsonLd,
  type StructuredDataTranslator,
} from "./structuredData";

export default function StructuredDataScripts() {
  const location = useLocation();
  const { lng } = useParams();
  const { i18n } = useTranslation();

  const language = isSupportedStructuredDataLanguage(lng) ? lng : "en";

  const entries = useMemo(() => {
    const translate: StructuredDataTranslator = (namespace, key, options) => {
      return i18n.getFixedT(language, namespace)(key, options as any) as any;
    };

    return buildStructuredData(location.pathname, language, translate);
  }, [i18n, language, location.pathname]);

  return (
    <>
      {entries.map((entry) => (
        <script
          key={entry.id}
          type="application/ld+json"
          data-schema-id={entry.id}
          dangerouslySetInnerHTML={{ __html: serializeJsonLd(entry.data) }}
        />
      ))}
    </>
  );
}
